import React, { useMemo } from 'react';
import { Grid } from 'antd';
import { useDrop } from 'react-dnd';
import styled from 'styled-components';

import { DownloadOutlined } from '@ant-design/icons';

import { useGetFileStorageFile } from '../common/useGetFileStorageFile';
import { useGetFileStorageToken } from '../common/useGetFilestorageToken';
import { UploadButton } from '../features/candidate-details/CandidatesPersonalData';

import { StyledColumn } from './StyledColumn';

const StyledEmbed = styled.embed`
  height: 100%;
  width: 100%;
`;

type CandidateCVProps = {
  fileId?: string;
};

export const CandidateCV: React.FC<CandidateCVProps> = ({ fileId }) => {
  const screens = Grid.useBreakpoint();

  const { data: token, isLoading: tokenLoading } = useGetFileStorageToken(fileId || '');

  const { data: fileToShow, isLoading: fileLoading } = useGetFileStorageFile(fileId, token?.token);

  const fileURL = useMemo(() => {
    if (fileToShow) {
      return URL.createObjectURL(fileToShow);
    }
  }, [fileToShow]);

  const [, cvUploadDrop] = useDrop({
    accept: 'email',
    drop: () => ({ name: 'candidate attachments' }),
  });

  if (!token || tokenLoading || !fileToShow || fileLoading) return <></>;
  const isFileNotPDF = fileToShow.type !== 'application/pdf';

  if (!screens.xl) {
    return (
      <StyledColumn>
        <div>
          <UploadButton>
            <a
              style={{ color: '#004ba0', display: 'flex', alignItems: 'center', background: 'transparent' }}
              href={fileURL}
              download
            >
              <DownloadOutlined style={{ marginRight: '8px' }} /> Download CV
            </a>
          </UploadButton>
        </div>
      </StyledColumn>
    );
  }

  if (isFileNotPDF)
    return (
      <StyledColumn style={{ height: '100%', justifyContent: 'center', alignItems: 'center' }}>
        <span>Preview is not available.</span>
        <div>
          <span>You can &nbsp;</span>
          <span>
            <UploadButton>
              <a style={{ color: '#004ba0' }} href={fileURL}>
                download
              </a>
            </UploadButton>
          </span>
          <span>&nbsp; file instead.</span>
        </div>
      </StyledColumn>
    );

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <StyledEmbed src={fileURL} style={{ height: isFileNotPDF ? '0px' : '100%' }} ref={cvUploadDrop} />
    </div>
  );
};
